window.product_gallery = {

  init: () => {
    const variant_select = document.querySelector('.product__grid select[name="id"]');
    
    if (!variant_select) {
      document.body.setAttribute('data-main-gallery', 1);
      return;
    }

    window.product_gallery._checkCurrentVariant();

    variant_select.addEventListener('change', () => {
      const variant_id = variant_select.value;
      if (variant_id) {
        window.product_gallery.check(variant_id);
      }
    });
  },

  check: (variant_id) => {
    const variant_gallery = document.querySelectorAll(`[data-variant-gallery="${variant_id}"]`);
    const gallery_exists = variant_gallery.length > 0;
    const main_variant_id = document.querySelector('product-page')?.getAttribute('data-main-variant-id');

    if (main_variant_id && String(variant_id) === String(main_variant_id)) {
      const all_galleries = document.querySelectorAll(`[data-variant-gallery]`);
      window.product_gallery._showMainGallery(all_galleries);
      return;
    }

    if (gallery_exists) {
      window.product_gallery.switch(variant_id);
    } else if (window.product_gallery._variantExists(variant_id)) {
      window.product_gallery.generate(variant_id);
    } else {
      const all_galleries = document.querySelectorAll(`[data-variant-gallery]`);
      window.product_gallery._showMainGallery(all_galleries);
    }
  },

  switch: (variant_id) => {
    const body_current_variant_id = parseFloat(document.body.getAttribute('data-current-variant-id')) || false;
    const all_galleries = document.querySelectorAll(`[data-variant-gallery]`);
    const galleries = document.querySelectorAll(`[data-variant-gallery="${variant_id}"]`);

    if (galleries.length) {
      window.product_gallery._switchToVariantGallery(variant_id, body_current_variant_id, all_galleries, galleries);
    } else {
      window.product_gallery._showMainGallery(all_galleries);
    }
  },

  generate: (variant_id) => {
    const h1_text = window.product_gallery._getProductTitle();
    const html_buttons = window.product_gallery._generateNavigationButtons();
    const pdp_mobile_gallery = document.querySelector('.pdp_mobile_gallery');
    const pdp_desktop_gallery = document.querySelector('.pdp_desktop_gallery');

    window.product_gallery._createDesktopGallery(pdp_desktop_gallery, variant_id, html_buttons);
    window.product_gallery._createMobileGallery(pdp_mobile_gallery, variant_id);

    const pdp_desktop_variant_gallery = pdp_desktop_gallery?.querySelector(`[data-variant-gallery="${variant_id}"]`);
    const pdp_mobile_variant_gallery = pdp_mobile_gallery?.querySelector(`[data-variant-gallery="${variant_id}"]`);

    if (!pdp_desktop_variant_gallery || !pdp_mobile_variant_gallery) return;

    const gallery_elements = window.product_gallery._getGalleryElements(
      pdp_desktop_variant_gallery, 
      pdp_mobile_variant_gallery, 
      pdp_desktop_gallery, 
      pdp_mobile_gallery
    );

    window.product_gallery._populateGallery(variant_id, h1_text, gallery_elements);
    window.product_gallery._initializeSwipersForVariant(pdp_desktop_variant_gallery, pdp_mobile_variant_gallery, gallery_elements);

    setTimeout(() => {
      window.product_gallery.switch(variant_id);
    }, 50);
  },

  _checkCurrentVariant: () => {
    const current_variant_select = document.querySelector('.product__grid select[name="id"]');
    const current_variant_id = current_variant_select?.value;

    if (current_variant_id) {
      window.product_gallery.check(current_variant_id);
    }
  },

  _variantExists: (variant_id) => {
    if (!window.variants_gallery_json || !Array.isArray(window.variants_gallery_json)) {
      return false;
    }
    return window.variants_gallery_json.some(v => String(v.variant_id) === String(variant_id));
  },

    _switchToVariantGallery: (variant_id, body_current_variant_id, all_galleries, galleries) => {
    all_galleries.forEach(gallery => gallery.classList.remove('is_active'));
    galleries.forEach(gallery => gallery.classList.add('is_active'));
    
    document.body.setAttribute('data-current-variant-id', variant_id);
    document.body.setAttribute('data-main-gallery', 0);
  },

  _showMainGallery: (all_galleries) => {
    all_galleries.forEach(gallery => gallery.classList.remove('is_active'));
    document.body.setAttribute('data-main-gallery', 1);
  },

  _getProductTitle: () => {
    const h1_element = document.querySelector('.product__grid h1');
    return h1_element ? h1_element.textContent.trim() : '';
  },

  _generateNavigationButtons: () => {
    const t = window.product_gallery._getButtonTranslations();
    
    return `
      <button class="arrow arrow--left" title="${t.button.prev.title}" aria-label="${t.button.prev.aria}" tabindex="0" aria-controls="swiper-wrapper-7e950dac879be170" aria-disabled="false"><svg role="presentation" class="icon icon--chevron-left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.785 54.68" width="34.785" height="54.68"><path d="M34.042 53.296a2.449 2.449 0 0 1-3.428.49L1.229 29.299a2.449 2.449 0 0 1 0-3.918L30.614.894a2.449 2.449 0 1 1 2.936 3.918L6.781 27.34 33.55 49.868a2.449 2.449 0 0 1 .492 3.428Z" fill="currentColor" stroke="currentColor" stroke-width=".5" fill-rule="evenodd"></path></svg> </button>
      <button class="arrow arrow--right" title="${t.button.next.title}" aria-label="${t.button.prev.aria}" tabindex="0" aria-controls="swiper-wrapper-7e950dac879be170" aria-disabled="false"><svg role="presentation" class="icon icon--chevron-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.785 54.68" width="34.785" height="54.68"><path d="M.743 53.296a2.449 2.449 0 0 0 3.428.49l29.382-24.487a2.449 2.449 0 0 0 0-3.918L4.171.894a2.449 2.449 0 1 0-2.938 3.918L28.004 27.34 1.233 49.868a2.449 2.449 0 0 0-.49 3.428Z" fill="currentColor" stroke="currentColor" stroke-width=".5" fill-rule="evenodd"></path></svg> </button>
    `;
  },

  _getButtonTranslations: () => {
    return {
      "button": {
        "prev": {
          "title": document.querySelector(".product__gallery--desktop .arrow--left")?.getAttribute("title") || '',
          "aria": document.querySelector(".product__gallery--desktop .arrow--left")?.getAttribute("aria-label") || ''
        },
        "next": {
          "title": document.querySelector(".product__gallery--desktop .arrow--right")?.getAttribute("title") || '',
          "aria": document.querySelector(".product__gallery--desktop .arrow--right")?.getAttribute("aria-label") || ''
        }
      }
    };
  },

  _createDesktopGallery: (pdp_desktop_gallery, variant_id, html_buttons) => {
    if (!pdp_desktop_gallery) return;
    
    pdp_desktop_gallery.insertAdjacentHTML('beforeend', `
      <div class="variant_gallery" data-variant-gallery="${variant_id}">
        <div class="swiper swiper--preview">
          <div class="swiper-wrapper"></div>
          ${html_buttons}
        </div>
        <div class="swiper swiper--thumbnails">
          <div class="swiper--thumbnails__inner">
            <div class="swiper--thumbnails__content">
              <div class="swiper-wrapper"></div>
            </div>
          </div>
          ${html_buttons}
        </div>
      </div>
    `);
  },

  _createMobileGallery: (pdp_mobile_gallery, variant_id) => {
    if (!pdp_mobile_gallery) return;
    
    pdp_mobile_gallery.insertAdjacentHTML('beforeend', `
      <div class="variant_gallery" data-variant-gallery="${variant_id}">
        <div class="swiper swiper--preview">
          <div class="swiper-wrapper"></div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    `);
  },

  _getGalleryElements: (pdp_desktop_variant_gallery, pdp_mobile_variant_gallery, pdp_desktop_gallery, pdp_mobile_gallery) => {
    return {
      desktop_preview_wrapper: pdp_desktop_variant_gallery.querySelector('.swiper--preview .swiper-wrapper'),
      desktop_thumbnails_wrapper: pdp_desktop_variant_gallery.querySelector('.swiper--thumbnails .swiper-wrapper'),
      mobile_preview_wrapper: pdp_mobile_variant_gallery.querySelector('.swiper--preview .swiper-wrapper'),
      desktop_self_videos: pdp_desktop_gallery.querySelectorAll('.product-page .product__grid video'),
      desktop_youtube_videos: pdp_desktop_gallery.querySelectorAll('.product-page .product__grid [data-youtube-id]'),
      mobile_self_videos: pdp_mobile_gallery.querySelectorAll('.product-page .product__grid video'),
      mobile_youtube_videos: pdp_mobile_gallery.querySelectorAll('.product-page .product__grid [data-youtube-id]')
    };
  },

  _populateGallery: (variant_id, h1_text, gallery_elements) => {
    const variant = window.variants_gallery_json.find(v => v.variant_id == variant_id);
    if (!variant) return;

    variant.gallery.forEach((item) => {
      const slides = window.product_gallery._createSlides(item, h1_text);
      
      gallery_elements.desktop_preview_wrapper.appendChild(slides.desktop_preview);
      gallery_elements.desktop_thumbnails_wrapper.appendChild(slides.desktop_thumb);
      gallery_elements.mobile_preview_wrapper.appendChild(slides.mobile_preview);
    });
  },

  _createSlides: (item, h1_text) => {
    if (item.media_type === 'image') {
      return window.product_gallery._createImageSlides(item, h1_text);
    } else if (item.media_type === 'video') {
      return window.product_gallery._createVideoSlides(item, h1_text);
    }
  },

  _createImageSlides: (item, h1_text) => {
    const desktop_preview_slide = document.createElement('div');
    desktop_preview_slide.className = 'swiper-slide';
    desktop_preview_slide.innerHTML = `
      <picture class="media media--image media--contain media--background">
        <source srcset="${item.src_768}" media="(max-width: 991px)">
        <source srcset="${item.src_820}" media="(min-width: 992px) and (max-width: 1599px)">
        <source srcset="${item.src_980}" media="(min-width: 1600px)">
        <img src="${item.src_400}" width="1" height="1" alt="${h1_text}" loading="lazy">
      </picture>`;

    const mobile_preview_slide = document.createElement('div');
    mobile_preview_slide.className = 'swiper-slide';
    mobile_preview_slide.innerHTML = `
      <picture class="media media--image media--contain media--background">
        <source srcset="${item.src_400}" media="(max-width: 400px)">
        <source srcset="${item.src_768}" media="(min-width: 401px) and (max-width: 767px)">
        <source srcset="${item.src_992}" media="(min-width: 768px)">
        <img src="${item.src_400}" width="1" height="1" alt="${h1_text}" loading="lazy">
      </picture>`;

    return {
      desktop_preview: desktop_preview_slide,
      desktop_thumb: desktop_preview_slide.cloneNode(true),
      mobile_preview: mobile_preview_slide
    };
  },

  _createVideoSlides: (item, h1_text) => {
    const video_html = `
      <video-player class="media media--video">
        <video 
          class="media"
          playsinline 
          autoplay
          loop
          muted 
          preload="metadata"
          poster="${item.preview_src}"
          controlsList="nodownload">
          <source src="${item.src_max}" type="video/mp4">
        </video>
      </video-player>`;

    const thumb_html = `
      <picture class="media media--image media--contain media--background">
        <img src="${item.preview_src}" alt="${h1_text}" loading="lazy">
      </picture>`;

    const desktop_preview_slide = document.createElement('div');
    desktop_preview_slide.className = 'swiper-slide';
    desktop_preview_slide.innerHTML = video_html;

    const desktop_thumb_slide = document.createElement('div');
    desktop_thumb_slide.className = 'swiper-slide';
    desktop_thumb_slide.innerHTML = thumb_html;

    const mobile_preview_slide = document.createElement('div');
    mobile_preview_slide.className = 'swiper-slide';
    mobile_preview_slide.innerHTML = video_html;

    return {
      desktop_preview: desktop_preview_slide,
      desktop_thumb: desktop_thumb_slide,
      mobile_preview: mobile_preview_slide
    };
  },

  _initializeSwipersForVariant: (pdp_desktop_variant_gallery, pdp_mobile_variant_gallery, gallery_elements) => {
    const desktop_swiper_thumbnails = window.product_gallery._createDesktopThumbnailsSwiper(pdp_desktop_variant_gallery);
    const desktop_swiper_preview = window.product_gallery._createDesktopPreviewSwiper(pdp_desktop_variant_gallery, desktop_swiper_thumbnails, gallery_elements);
    const mobile_swiper_preview = window.product_gallery._createMobilePreviewSwiper(pdp_mobile_variant_gallery, gallery_elements);
  },

  _createDesktopThumbnailsSwiper: (pdp_desktop_variant_gallery) => {
    return new Swiper(pdp_desktop_variant_gallery.querySelector('.swiper--thumbnails__content'), {
      loop: false,
      grabCursor: true,
      speed: 500, 
      spaceBetween: 15,
      slidesPerView: 4,
      watchSlidesProgress: true,
      centerInsufficientSlides: true,
      navigation: { 
        prevEl: pdp_desktop_variant_gallery.querySelector('.swiper--thumbnails .arrow--left'),
        nextEl: pdp_desktop_variant_gallery.querySelector('.swiper--thumbnails .arrow--right')
      },
      breakpoints: {
        1200: {
          spaceBetween: 20,
          slidesPerView: 5
        },
        1600: {
          spaceBetween: 30,
          slidesPerView: 5
        }
      }
    });
  },

  _createDesktopPreviewSwiper: (pdp_desktop_variant_gallery, desktop_swiper_thumbnails, gallery_elements) => {
    return new Swiper(pdp_desktop_variant_gallery.querySelector('.swiper--preview'), {
      loop: false,
      grabCursor: true,
      speed: 500, 
      spaceBetween: 0,
      slidesPerView: 1,
      watchSlidesProgress: true,
      navigation: { 
        prevEl: pdp_desktop_variant_gallery.querySelector('.swiper--preview .arrow--left'),
        nextEl: pdp_desktop_variant_gallery.querySelector('.swiper--preview .arrow--right')
      },
      thumbs: {
        swiper: desktop_swiper_thumbnails
      },
      on: {
        realIndexChange: swiper => {
          window.product_gallery._handleSlideChange(swiper, gallery_elements.desktop_self_videos, gallery_elements.desktop_youtube_videos);
        }
      }
    });
  },

  _createMobilePreviewSwiper: (pdp_mobile_variant_gallery, gallery_elements) => {
    return new Swiper(pdp_mobile_variant_gallery.querySelector('.swiper--preview'), {
      loop: true,
      grabCursor: true,
      speed: 500, 
      spaceBetween: 0,
      slidesPerView: 1,
      watchSlidesProgress: true,
      pagination: {
        el: pdp_mobile_variant_gallery.querySelector('.swiper-pagination'),
        clickable: true
      },
      on: {
        realIndexChange: swiper => {
          window.product_gallery._handleSlideChange(swiper, gallery_elements.mobile_self_videos, gallery_elements.mobile_youtube_videos);
        }
      }
    });
  },

  _handleSlideChange: (swiper, self_videos, youtube_videos) => {
    self_videos.forEach(video => video.pause());
    youtube_videos.forEach(video => video.pauseYouTube());

    const active_slide = swiper.slides[swiper.activeIndex];
    const video_element = active_slide.querySelector('video');
    const youtube_element = active_slide.querySelector('[data-youtube-id]');

    if (video_element) {
      video_element.currentTime = 0;
      video_element.play();
    }

    if (youtube_element) {
      youtube_element.playYouTube();
    }
  }

};

window.product_gallery.init();

let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    window.product_gallery._handleResize();
  }, 250);
});

window.product_gallery._handleResize = () => {
  const current_variant_select = document.querySelector('.product__grid select[name="id"]');
  const current_variant_id = current_variant_select?.value;

  if (current_variant_id) {
    window.product_gallery.check(current_variant_id);
  }
};
